<page-loading class="card_loading" *ngIf="loading"></page-loading>

<div class="body" *ngIf="!loading">
  <header>
    <h1>{{ titleOnline }}</h1>
    <i icon="close" class="icons_close" (click)="chance('no')"></i>
  </header>

  <section *ngIf="!loading && phase === 1">
    <h3>Confirmar valor da compra</h3>
    <h2>{{ convertMoney(data.animal_obj.super_bid) }}</h2>
  </section>

  <section *ngIf="!loading && phase === 2">
    <h3>Tem certeza desse lance?</h3>
    <h2>{{ convertMoney(data.animal_obj.super_bid)}}</h2>
  </section>

  <section *ngIf="!loading && phase === 3">
    <h3>Lance feito com sucesso!</h3>
  </section>

  <footer>
    <button mat-button class="cancell" (click)="chance('no')">FECHAR</button>
    <button
      mat-button
      *ngIf="phase !== 4"
      class="primary"
      (click)="nextPhase()"
    >
      {{ phase === 2 ? 'CONFIRMAR' : 'SIM' }}
    </button>
  </footer>
</div>
